"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSpamSettings = canSpamSettings;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _CanSpamSettingsUtils = require("lead-flows-ui/utils/CanSpamSettingsUtils");

var _underscore = require("underscore");

var INITIAL_STATE = {
  canSpamSettings: {
    hasLoaded: false,
    fetchingHasError: false,
    hasChangesError: false,
    saving: false,
    savingHasError: false,
    savingRecentError: undefined,
    fetchingRecentError: undefined,
    editableCanSpamSettings: {
      objects: [{
        companyName: undefined,
        companyStreetAddress_1: undefined,
        companyStreetAddress_2: undefined,
        companyCity: undefined,
        companyState: undefined,
        companyZip: undefined,
        companyCountry: undefined,
        isDefault: true,
        name: 'default'
      }]
    },
    originalCanSpamSettings: {
      objects: [{
        companyName: undefined,
        companyStreetAddress_1: undefined,
        companyStreetAddress_2: undefined,
        companyCity: undefined,
        companyState: undefined,
        companyZip: undefined,
        companyCountry: undefined,
        isDefault: true,
        name: 'default'
      }]
    }
  }
};

function maybeIncludeInitialDefault() {
  var incomingCanSpamSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasDefault = (0, _CanSpamSettingsUtils.getDefaultCanSpamAddressIndex)(incomingCanSpamSettings) !== null;

  if (!hasDefault) {
    return Object.assign({}, incomingCanSpamSettings, {
      objects: [].concat((0, _toConsumableArray2.default)(INITIAL_STATE.canSpamSettings.originalCanSpamSettings.objects), (0, _toConsumableArray2.default)(incomingCanSpamSettings.objects || []))
    });
  }

  return incomingCanSpamSettings;
}

function canSpamSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.canSpamSettings;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var defaultIndex = (0, _CanSpamSettingsUtils.getDefaultCanSpamAddressIndex)(state.editableCanSpamSettings);
  var indexOfDefault = (0, _CanSpamSettingsUtils.getDefaultCanSpamAddressIndex)(state.editableCanSpamSettings);

  switch (action.type) {
    case _ActionTypes.REQUEST_CAN_SPAM_SETTINGS_FOR_EDITOR:
      return Object.assign({}, state, {
        hasLoaded: false
      });

    case _ActionTypes.RECEIVE_CAN_SPAM_SETTINGS_FOR_EDITOR:
      if ((0, _underscore.isEmpty)(action.payload.objects)) {
        return Object.assign({}, state, {
          hasLoaded: true
        });
      }

      return Object.assign({}, state, {
        hasLoaded: true,
        originalCanSpamSettings: Object.assign({}, state.originalCanSpamSettings, (0, _extends2.default)({}, maybeIncludeInitialDefault(action.payload))),
        editableCanSpamSettings: Object.assign({}, state.editableCanSpamSettings, (0, _extends2.default)({}, maybeIncludeInitialDefault(action.payload)))
      });

    case _ActionTypes.ERROR_CAN_SPAM_SETTINGS:
      return Object.assign({}, state, {
        hasLoaded: true,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.UPDATE_EDITABLE_CAN_SPAM_SETTINGS:
      if (defaultIndex === null) {
        return Object.assign({}, state, {
          hasChangesError: true,
          fetchingRecentError: action.payload
        });
      }

      return Object.assign({}, state, {
        hasChanges: true,
        editableCanSpamSettings: Object.assign({}, state.editableCanSpamSettings, {
          objects: Object.assign({}, state.editableCanSpamSettings.objects, (0, _defineProperty2.default)({}, defaultIndex, Object.assign({}, state.editableCanSpamSettings.objects[defaultIndex], action.payload)))
        })
      });

    case _ActionTypes.SAVE_CAN_SPAM_SETTINGS:
      return Object.assign({}, state, {
        saving: true
      });

    case _ActionTypes.SAVE_CAN_SPAM_SETTINGS_SUCCESS:
      if (indexOfDefault === null) {
        return Object.assign({}, state, {
          hasChangesError: true,
          fetchingRecentError: action.payload
        });
      }

      return Object.assign({}, state, {
        saving: false,
        savingHasError: false,
        hasChanges: false,
        editableCanSpamSettings: Object.assign({}, state.editableCanSpamSettings, {
          objects: Object.assign({}, state.editableCanSpamSettings.objects, (0, _defineProperty2.default)({}, indexOfDefault, Object.assign({}, state.editableCanSpamSettings.objects[indexOfDefault], action.payload)))
        }),
        originalCanSpamSettings: Object.assign({}, state.editableCanSpamSettings, {
          objects: Object.assign({}, state.editableCanSpamSettings.objects, (0, _defineProperty2.default)({}, indexOfDefault, Object.assign({}, state.editableCanSpamSettings.objects[indexOfDefault], action.payload)))
        })
      });

    case _ActionTypes.SAVE_CAN_SPAM_SETTINGS_ERROR:
      return Object.assign({}, state, {
        saving: false,
        savingHasError: true,
        savingRecentError: action.payload
      });

    case _ActionTypes.REMOVE_CAN_SPAM_SETTINGS_LOADING_ERROR:
      return Object.assign({}, state, {
        fetchingHasError: false
      });

    case _ActionTypes.REMOVE_CAN_SPAM_SETTINGS_SAVE_ERROR:
      return Object.assign({}, state, {
        savingHasError: false
      });

    default:
      return state;
  }
}